import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (('' + _vm.field).length <= _vm.max_text_size || _vm.is_mobile)?_c('span',{class:_vm.css_class},[_vm._v("\n  "+_vm._s(_vm.representation)+"\n")]):_c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({class:_vm.css_class,staticStyle:{"cursor":"default"}},'span',attrs,false),on),[_vm._v("\n      "+_vm._s(_vm.representation)+"\n    ")])]}}])},[_c('span',{class:_vm.css_class},[_vm._v(_vm._s(_vm.field))])])}
var staticRenderFns = []

export { render, staticRenderFns }